import React from 'react'

const AndroidIcon = props => {
  const height = props.height || 32
  const width = props.width || 32
  const color = props.color || '#1D6C90'
  const strokeWidth = props.strokeWidth || '1'
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" strokeWidth={strokeWidth}>
      <g fillRule="nonzero" fill="none">
        <path
          d="M22.833 9.752H9.167a3.22 3.22 0 0 0-3.224 3.217v9.126a3.22 3.22 0 0 0 3.224 3.216h2.461v3.347c0 .021.024.033.041.021l5.038-3.33 1.263-.024h3.545l1.318-.014a3.22 3.22 0 0 0 3.224-3.216V12.97a3.22 3.22 0 0 0-3.224-3.217zM11.16 14.587c0-.889.722-1.61 1.614-1.61.891 0 1.613.721 1.613 1.61 0 .89-.722 1.61-1.613 1.61-.892 0-1.614-.72-1.614-1.61zm4.766 8.044c-2.046 0-3.736-1.43-3.995-3.282h7.99c-.26 1.852-1.95 3.282-3.995 3.282zm3.32-6.434c-.89 0-1.614-.72-1.614-1.61 0-.889.723-1.61 1.614-1.61.892 0 1.614.721 1.614 1.61 0 .89-.722 1.61-1.614 1.61z"
          stroke={color}
        />
        <path className='bot-head'
          d="M17.829 5.634a1.37 1.37 0 0 1-.976 1.31v1.182h-.792V6.944a1.37 1.37 0 0 1-.975-1.31 1.371 1.371 0 0 1 2.743 0zM3.2 18.95v-3.586c0-.575.467-1.04 1.042-1.04h.787v5.666h-.787A1.041 1.041 0 0 1 3.2 18.95zM28.8 18.95v-3.586c0-.575-.467-1.04-1.042-1.04h-.787v5.666h.787c.575 0 1.042-.466 1.042-1.04z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default AndroidIcon
